<template>
  <div>
    <div class="mb-4 relative">
      <ValidationProvider rules="email|min:2" v-slot="{ errors, invalid }">
        <zt-input
          class="zt-input-first-login-email"
          outlined
          name="email"
          :label="$t('message.loginComponent.languagesVuetify.inputMail')"
          :style="[firstLoginCustomParamsFields.styles.form.inputs.bgColor]"
          :color="colorOutlineEmail(invalid)"
          v-model="value.email"
          :key="key"
          data-vs-input="auth-firstlogin-fields-input-email"
        />
        <span class="text-zt-danger absolute left-0" v-show="errors[0]"
          >{{ $t('message.loginComponent.validations.emailRules.validMail') }}
        </span>
        <span
          class="text-zt-md mt-3 block"
          :style="[firstLoginCustomParamsFields.styles.form.textColor]">
          {{ $t('message.loginComponent.firstLogin.rememberValidMail') }}
        </span>
      </ValidationProvider>
    </div>
    <div class="mb-4 relative">
      <ValidationProvider
        name="confirm"
        rules="required|min:8"
        v-slot="{ errors, invalid }"
      >
        <div class="flex items-center">
          <zt-tooltip
            :position="isMobile ? 'top' : 'left'"
            :clickable="true"
            color="dark-300"
            outlined
            :shadow="true"
            class="w-full"
          >
            <div slot="body" class="p-3">
              <PasswordPolicies :pass-policies="passwordPolicies" />
            </div>
            <zt-input
              class="zt-input-first-login-new-pass"
              outlined
              name="password"
              type="password"
              v-model="value.password"
              :label="$t('message.loginComponent.languagesVuetify.newPassword')"
              :style="[firstLoginCustomParamsFields.styles.form.inputs.bgColor]"
              :color="colorOutlinePass(invalid)"
              data-vs-input="auth-firstlogin-fields-input-pass"
            />
          </zt-tooltip>
        </div>
        <span class="text-zt-danger absolute left-0" v-show="errors[0]"
          >{{
            $t('message.loginComponent.validations.passwordRules.requirePass')
          }}
        </span>
      </ValidationProvider>
    </div>
    <div class="mb-10 relative">
      <ValidationProvider
        rules="required|password:@confirm"
        v-slot="{ errors, invalid, dirty }"
      >
        <zt-input
          class="zt-input-first-login-re-new-pass"
          outlined
          name="rePassword"
          type="password"
          :label="$t('message.loginComponent.languagesVuetify.repeatPassword')"
          :style="[firstLoginCustomParamsFields.styles.form.inputs.bgColor]"
          :color="colorOutlineRePass(invalid)"
          v-model="value.rePassword"
          data-vs-input="auth-firstlogin-fields-input-repass"
        />
        <span class="text-zt-danger absolute left-0" v-show="errors[0] && dirty"
          >{{
            $t(
              'message.settingsComponent.list.changePassword.samePassValidation'
            )
          }}
        </span>
      </ValidationProvider>
    </div>
    <div class="mb-3 relative">
      <ValidationProvider :rules="{ required: { allowFalse: false } }">
        <zt-check-box
          class="zt-input-first-login-check-terms"
          v-model="value.activeTermsConditions"
          name="terms"
          color="secondary"
          :style="[firstLoginCustomParamsFields.styles.form.textColor]"
          data-vs-check="auth-firstlogin-fields-check-terms"
        >
          {{ $t('message.loginComponent.firstLogin.accept') }}
          <a
            href="https://community.sichern.com/t5/Sabias-que/POLITICA-DE-PRIVACIDAD-DE-LA-PLATAFORMA-SICHERN/ta-p/567941"
            target="_blank"
            class="underline"
            :style="[firstLoginCustomParamsFields.styles.form.textColor]"
            data-vs-link="auth-firstlogin-fields-link-pdf"
            >{{ $t('message.loginComponent.firstLogin.termsAndConditions') }}</a
          >
        </zt-check-box>
      </ValidationProvider>
    </div>
  </div>
</template>

<script>
import { extend } from 'vee-validate'
import PasswordPolicies from '@/components/generics/passwordPolicies'
import { useWindowResize } from '@sichern/ui-elements'

extend('password', {
  params: ['target'],
  validate(value, { target }) {
    return value === target
  },
  message: ''
})

export default {
  name: 'ztAuthFirstLoginFields',
  components: {
    PasswordPolicies
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        email: '',
        password: '',
        rePassword: '',
        activeTermsConditions: false
      })
    },
    firstLoginCustomParamsFields: {
      type: Object,
      default: () => {}
    },
    passwordPolicies: {
      type: Object,
      default: {}
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  computed: {
    colorOutlineEmail() {
      return invalid =>
        invalid
          ? 'danger'
          : this.firstLoginCustomParamsFields.styles.form.inputs.outlineColor
    },
    colorOutlinePass() {
      return invalid =>
        invalid
          ? 'danger'
          : this.firstLoginCustomParamsFields.styles.form.inputs.outlineColor
    },
    colorOutlineRePass() {
      return invalid =>
        invalid
          ? 'danger'
          : this.firstLoginCustomParamsFields.styles.form.inputs.outlineColor
    },
    isMobile() {
      return this.windowSize.width < 1024
    },
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE,
      key: 0,
      windowSize: useWindowResize(this)
    }
  },
  methods: {
    keyInput() {
      this.key++
    }
  },
  mounted() {
    this.keyInput()
  }
}
</script>

<style scoped></style>
